"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactBlueprintLibrary = require("react-blueprint-library");
var _FooterSubscribe = _interopRequireDefault(require("./FooterSubscribe"));
var _FooterSubscribeWithForm = _interopRequireDefault(require("./FooterSubscribeWithForm"));
var _constants = require("../../utils/constants");
var _lodash = require("lodash");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var FooterNav = props => {
  var siteFooterNav = props.fields.SiteFooterNav.value;
  var apiUrl = '/apicalls/navfooter/';
  if (props.componentParams.testApp == 'scTestGroove') {
    apiUrl = "".concat(apiUrl, "?app=").concat(props.componentParams.appName);
    if (!(0, _lodash.isEmpty)(siteFooterNav)) apiUrl = "".concat(apiUrl, "&sitemodule=").concat(siteFooterNav.toLowerCase());
  } else if (!(0, _lodash.isEmpty)(siteFooterNav)) {
    apiUrl = "".concat(apiUrl, "?sitemodule=").concat(siteFooterNav.toLowerCase());
  }
  var dataFooterLegal = null;
  var [error, setError] = (0, _react.useState)(null);
  var [isLoaded, setIsLoaded] = (0, _react.useState)(false);
  var [items, setItems] = (0, _react.useState)([]);
  (0, _react.useEffect)(() => {
    fetch(apiUrl).then(res => res.json()).then(result => {
      setIsLoaded(true);
      setItems(result);
    }, error => {
      setIsLoaded(false);
      setError(error);
    });
  }, []);
  /**
   * Function to get respective env url
   *
   * @param {string} defTitle Default title of link
   * @returns {string} the full qualified path
   */
  function getUrl(defTitle) {
    if (dataFooterLegal) {
      var _legalLink$link;
      var legalLink = dataFooterLegal.find(item => item.linkname === defTitle);
      if (legalLink) return (_legalLink$link = legalLink.link) === null || _legalLink$link === void 0 ? void 0 : _legalLink$link.url;
    }
    return '';
  }
  var NewsSubscription = () => {
    var _props$fields$NavSett, _props$fields$NavSett2;
    if (!((_props$fields$NavSett = props.fields.NavSetting.fields.NewsSubscribe) !== null && _props$fields$NavSett !== void 0 && _props$fields$NavSett.fields) || !((_props$fields$NavSett2 = props.fields.NavSetting.fields.NewsSubscribe) !== null && _props$fields$NavSett2 !== void 0 && (_props$fields$NavSett2 = _props$fields$NavSett2.fields.SusbscribeForm) !== null && _props$fields$NavSett2 !== void 0 && _props$fields$NavSett2.fields)) return null;
    var fieldSubscribe = props.fields.NavSetting.fields.NewsSubscribe.fields;
    if ((0, _lodash.isEmpty)(fieldSubscribe.SusbscribeForm.fields.Key.value)) return null;else if (fieldSubscribe.SusbscribeForm.fields.Key.value === 'link-to-form') {
      return /*#__PURE__*/_react.default.createElement(_FooterSubscribe.default, {
        fields: fieldSubscribe,
        params: props.params
      });
    } else {
      return /*#__PURE__*/_react.default.createElement(_FooterSubscribeWithForm.default, {
        fields: fieldSubscribe,
        params: props.params
      });
    }
  };
  var LegalCPRA = cpra => {
    if (cpra && cpra.link && !(0, _lodash.isEmpty)(cpra.label)) {
      var linkTarget = (0, _lodash.isEmpty)(cpra.link.target) ? '_blank' : cpra.link.target;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "container"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "row"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "col-12"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "legal-cpra caption"
      }, /*#__PURE__*/_react.default.createElement("a", {
        href: cpra.link.url,
        target: linkTarget
      }, cpra.label)))));
    } else return null;
  };
  if (isLoaded) {
    var _items$navfooter, _props$fields$Complia;
    dataFooterLegal = (_items$navfooter = items.navfooter) === null || _items$navfooter === void 0 ? void 0 : _items$navfooter.footerLegalNav;
    var navSetting = props.fields.NavSetting.fields;
    var cpra = dataFooterLegal ? dataFooterLegal.find(item => item.linkname === _constants.CPRA) : null;
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, navSetting.IncludeNewsSubscribe.value && /*#__PURE__*/_react.default.createElement(NewsSubscription, null), navSetting.IncludeFooterNav.value && /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.FooterSitemap, {
      tree: Object.assign({}, items)
    }), navSetting.IncludeFooterLegal.value && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.FooterLegal, {
      crn: (_props$fields$Complia = props.fields.ComplianceNumber) === null || _props$fields$Complia === void 0 ? void 0 : _props$fields$Complia.value,
      terms_of_use_url: getUrl(_constants.TERMS_OF_USE),
      privacy_policy_url: getUrl(_constants.PRIVACY),
      sitemap: getUrl(_constants.SITEMAP)
    }), /*#__PURE__*/_react.default.createElement(LegalCPRA, cpra)));
  } else return null;
};
var _default = exports.default = FooterNav;